module.exports = __webpack_public_path__ + "d2f3a79057fd86f16e2e07fc42aeb91e.svg";


//////////////////
// WEBPACK FOOTER
// ./components/main/pause.svg
// module id = b0iH
// module chunks = 0